import axios from 'axios';
import type { AxiosInstance } from 'axios';

/**
 * The client for calls to WX with the WX JWT.
 *
 * `utils/axios` registers its 401 handler on the global axios instance, so a
 * plain `import axios from 'axios'` gets it too, and a WX 401 would sign the
 * recruiter out of Hire. Interceptors belong to one instance; this one has none.
 * A rejected WX token hides the WX surface that needed it. A revoked WX session
 * does not end the Hire session: `verify_wx_jwt` skips the sign-out on
 * `server_inactive` and signs out only once the stored JWT expires.
 */
export const wxAxios: AxiosInstance = axios.create();

/**
 * Whether the stored WX JWT was fetched for the account being viewed.
 *
 * `useWxJwtReady` reports ready at once for an account off unified auth, since
 * the navbar needs no token there. Storage can still hold a token from an
 * account seen earlier, which WX rejects. Only a unified-auth account fetches
 * a token for itself.
 */
export const hasWxJwtForAccount = (
  whoami: { account_unified_auth?: boolean } | null | undefined,
  isJwtReady: boolean,
): boolean => isJwtReady && whoami?.account_unified_auth === true;
